import { IdType } from "../Utils/IdType";

export const addSuccessMessage = (id: IdType, objectName: string) =>
  `The ${objectName} with the Id ${id} has been created`;

export const updateSuccessMessage = (id: IdType, objectName: string) =>
  `Updating the ${objectName} with the Id ${id} was successful`;

export const deleteSuccessMessage = (id: IdType, objectName: string) =>
  `Deleting the ${objectName} with the Id ${id} was successful`;
